import { Company } from "@/app/core/models/domain/Company";
import { Actions, createComposable, Getters, Module, Mutations } from "vuex-smart-module";
import { Insurance } from "@/app/core/models/domain/Insurance";
import { Document } from "@/app/core/models/domain/Document";
import { DocumentType } from "@/app/core/enums/DocumentType";
import { Billing } from "@/app/core/models/domain/Billing";
import { PaymentProfile } from "@/app/core/models/domain/PaymentProfile";
import { PaymentTypeEnum } from "@/app/core/enums/PaymentTypeEnum";
import { Equipment } from "@/app/core/models/domain/Equipment";
import { PreferredRouteContract } from "@/app/core/interfaces/services/check-route/PreferredRouteContract";
import { UpdatePreferredRouteContract } from "@/app/core/interfaces/services/preferred-routes/UpdatePreferredRouteContract";
import { CreatePreferredRouteContract } from "@/app/core/interfaces/services/preferred-routes/CreatePreferredRouteContract";

// Import functional API endpoints
import { getDocuments} from '@/api';

export class ProfileState {
  // COMMENTED OUT - User functionality moved to Pinia UserStore (src/store/user.ts)
  // user: UserResponseContract | null = null;
  company: Company | null = null;
  insurance: Insurance | null = null;
  documents: Document[] | null = null;
  billing: Billing | null = null;
  paymentProfiles: PaymentProfile[] | null = null;
  equipment: Equipment | null = null;
  preferredRoutes: PreferredRouteContract[] = [];
}
export class ProfileGetters extends Getters<ProfileState> {
  // COMMENTED OUT - User functionality moved to Pinia UserStore (src/store/user.ts)
  // get getUser(): UserResponseContract | null {
  //   return this.state.user || null;
  // }
  get company(): Company | null {
    return this.state.company;
  }
  get getInsurance(): Insurance | null {
    return this.state.insurance;
  }
  get getDocuments(): Document[] | null {
    return this.state.documents;
  }
  get getCoi(): Document | undefined {
    return this.state.documents?.find((x) => x.type === DocumentType.COI);
  }
  get getW9(): Document | undefined {
    return this.state.documents?.find((x) => x.type === DocumentType.W9);
  }
  get getVoidCheck(): Document | undefined {
    return this.state.documents?.find((x) => x.type === DocumentType.VoidCheck);
  }
  // COMMENTED OUT - Avatar functionality moved to Pinia UserStore
  // get getAvatarHref(): string {
  //   const user = this.getUser;
  //   if (!user?.photo) {
  //     return "/static/icons/shared/avatar.svg";
  //   }
  //   return (
  //   );
  // }
  get getBilling(): Billing | null {
    return this.state.billing;
  }
  get getPaymentProfiles(): PaymentProfile[] | null {
    return this.state.paymentProfiles;
  }
  get getAch(): PaymentProfile | undefined {
    return this.state.paymentProfiles?.find((x) => x.paymentType.name === PaymentTypeEnum.ACH);
  }
  get getCheck(): PaymentProfile | undefined {
    return this.state.paymentProfiles?.find(
      (x) => x.paymentType.name === PaymentTypeEnum.Check
    );
  }
  get getZelle(): PaymentProfile | undefined {
    return this.state.paymentProfiles?.find(
      (x) => x.paymentType.name === PaymentTypeEnum.Zelle
    );
  }
  get getVenmo(): PaymentProfile | undefined {
    return this.state.paymentProfiles?.find(
      (x) => x.paymentType.name === PaymentTypeEnum.Venmo
    );
  }
  get getCashapp(): PaymentProfile | undefined {
    return this.state.paymentProfiles?.find(
      (x) => x.paymentType.name === PaymentTypeEnum.Cashapp
    );
  }
  get getInvoice(): PaymentProfile | undefined {
    return this.state.paymentProfiles?.find(
      (x) => x.paymentType.name === PaymentTypeEnum.Invoice
    );
  }
  get getQuickPay(): PaymentProfile | undefined {
    return this.state.paymentProfiles?.find(
      (x) => x.paymentType.name === PaymentTypeEnum.QuickPay
    );
  }
  get getEquipment(): Equipment | null {
    return this.state.equipment;
  }
  get getPreferredRoutes(): PreferredRouteContract[] {
    return this.state.preferredRoutes;
  }
}
export class ProfileMutations extends Mutations<ProfileState> {
  // COMMENTED OUT - User functionality moved to Pinia UserStore (src/store/user.ts)
  // setUser(payload: UserResponseContract | null) {
  //   this.state.user = payload;
  // }
  setCompany(payload: Company) {
    this.state.company = payload;
  }
  setInsurance(payload: Insurance) {
    this.state.insurance = payload;
  }
  setDocuments(payload: Document[]) {
    this.state.documents = payload;
  }
  setBilling(payload: Billing) {
    this.state.billing = payload;
  }
  setPaymentProfiles(payload: PaymentProfile[]) {
    this.state.paymentProfiles = payload;
  }
  setEquipment(payload: Equipment) {
    this.state.equipment = payload;
  }
  setPreferredRoutes(payload: PreferredRouteContract[]): void {
    this.state.preferredRoutes = payload;
  }
  addPreferredRoutes(payload: PreferredRouteContract): void {
    this.state.preferredRoutes?.push(payload);
  }

  updatePreferredRoutes(payload: PreferredRouteContract): void {
    const index = this.state.preferredRoutes!.findIndex((el) => el.id == payload.id);
    this.state.preferredRoutes![index] = payload;
  }
}
export class ProfileActions extends Actions<
  ProfileState,
  ProfileGetters,
  ProfileMutations,
  ProfileActions
> {
  // COMMENTED OUT - User functionality moved to Pinia UserStore (src/store/user.ts)
  // async fetchUser() {
  //   this.mutations.setUser(response);
  // }
  async fetchDocuments() {
    try {
      const response = await getDocuments();
      this.mutations.setDocuments(response.data || response);
    } catch (error) {
      console.error("Failed to fetch documents:", error);
    }
  }
}
export const profileModule = new Module({
  state: ProfileState,
  getters: ProfileGetters,
  mutations: ProfileMutations,
  actions: ProfileActions,
});
export const useProfileModule = createComposable(profileModule);
